import script from "./BitrixAccountSelectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BitrixAccountSelectModal.vue?vue&type=script&setup=true&lang=js"

import "./BitrixAccountSelectModal.vue?vue&type=style&index=0&id=43c138ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c138ba"]])

export default __exports__